import React, { useState } from 'react';
import { Title, TitleContainer, Text, Date, EventContainer, InputWrapper, NoData, Note } from './EnterFullName.styles';

import Input from '../../../components/utils/Input/Input';
import Button from '../../../components/utils/Button/Button';
import { useNavigate } from 'react-router-dom';
import FormContainer from '../../utils/FormContainer/FormContainer';
import { useDispatch, useSelector } from 'react-redux';
import { findGuest } from '../../../store/slice/rsvp/asyncThunks';
import { selectFetchRSVPDetailsPending, selectFindGuestPending, selectRSVPInfo } from '../../../store/slice/rsvp/slice';
import { Waveform } from '@uiball/loaders';
import { dateFormatter } from '../../../utils/utils';

const EnterFullName = ({ rsvpKey }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [noFound, setNoFound] = useState('');

  const rsvp = useSelector(selectRSVPInfo);
  const fetchRSVPDetailsPending = useSelector(selectFetchRSVPDetailsPending);
  const findGuestPending = useSelector(selectFindGuestPending);

  const onContinue = () => {
    setNoFound('');
    dispatch(findGuest({ firstName, lastName, rsvpKey }))
      .unwrap()
      .then(data => {
        if (!data.data.data.length) {
          setNoFound('Guest not found');
        } else {
          if (data.data.completed) {
            const query = { key: rsvpKey, step: 'SUBMITTED' };
            const queryString = new URLSearchParams(query).toString();
            const url = `/wedding-guest?${queryString}`;
            navigate(url);
          } else {
            const query = { key: rsvpKey, step: 'SELECTINFO' };
            const queryString = new URLSearchParams(query).toString();
            const url = `/wedding-guest?${queryString}`;
            navigate(url);
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  return (
    <>
      {fetchRSVPDetailsPending ? (
        <Waveform size={26} lineWeight={3.5} speed={1} color="black" />
      ) : (
        <FormContainer subtitle={`You're Invited!`}>
          <TitleContainer>
            <Title>{`${rsvp.brideName} & ${rsvp.groomName} !`}</Title>
            <Date>{dateFormatter(rsvp.dateOfWedding)}</Date>
            <EventContainer>
              <Text>{rsvp.venueName}</Text>
              {rsvp.venueAddress && <Text>{rsvp.venueAddress}</Text>}
            </EventContainer>
          </TitleContainer>
          <Text>Please enter your first and last name to begin your R.S.V.P. </Text>
          <InputWrapper>
            <Input placeholder={'Enter First Name'} value={firstName} onChange={e => setFirstName(e.target.value)} />
            <Input placeholder={'Enter Last Name'} value={lastName} onChange={e => setLastName(e.target.value)} />
          </InputWrapper>
          {noFound && <NoData>{noFound}</NoData>}
          <Button
            title={'Continue'}
            disabled={!firstName || !lastName || findGuestPending}
            onClick={onContinue}
            width
            loading={findGuestPending}
          />
          <Note>
            By clicking continue you agree to receive wedding related messages from the couple. You can opt out at any
            time by replying STOP to the message from Twilio.
          </Note>
        </FormContainer>
      )}
    </>
  );
};

export default EnterFullName;
